import config from '../../config'

const getInspectionRemindersRequest = ({ airportId }) => ({
  method: 'get',
  url: `${config.baseUrl}/${airportId}/Reminders/Inspection`,
})

export default getInspectionRemindersRequest
